// extracted by mini-css-extract-plugin
module.exports = {"button":"edit-button_button__1NTtL","icon":"edit-button_icon__eklYm"};